module.exports = __webpack_public_path__ + "static/img/D4105.3db742bc.png";